const FOCUSABLE_SELECTOR = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled]):not([type='hidden'])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "[tabindex]:not([tabindex='-1'])",
    "[contenteditable='true']",
].join(",");

const FORM_CONTROL_SELECTOR = [
    "input:not([disabled]):not([type='hidden']):not([type='submit']):not([type='button'])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "[contenteditable='true']",
    "[role='combobox']:not([aria-disabled='true'])",
    "[role='textbox']:not([aria-disabled='true'])",
].join(",");

function visible(nodes: NodeListOf<HTMLElement>): HTMLElement[] {
    return Array.from(nodes).filter((node) => !node.hasAttribute("aria-hidden"));
}

/** Tabbable descendants of `container` in DOM order. */
export function getFocusableElements(container: HTMLElement): HTMLElement[] {
    return visible(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR));
}

/** Descendants that take text or a choice, in DOM order. Buttons are not form controls here. */
export function getFormControls(container: HTMLElement): HTMLElement[] {
    return visible(container.querySelectorAll<HTMLElement>(FORM_CONTROL_SELECTOR));
}

/** Focus `element` without scrolling the page when the browser supports it. */
export function focusElement(element: HTMLElement | null | undefined): boolean {
    if (element === null || element === undefined) return false;
    element.focus({ preventScroll: true });
    return document.activeElement === element;
}
